/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
 * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
 */
import {
    AsyncResult,
    callActionOrExecute,
    DataServiceQuery,
    IContext,
    IDataServiceRequest,
    // @ts-ignore -- Unused import
    IQueryResultSettings,
    // @ts-ignore -- Unused import
    NullResult
} from '@msdyn365-commerce/retail-proxy';
// @ts-ignore -- Unused import
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
// @ts-ignore -- Unused import
import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
import * as DataServiceEntities from './DataServiceEntities.g';

// @ts-ignore
function klaviyoProfileQuery(id?: string): DataServiceQuery {
    const key = id ? { Id: id } : null;
    return new DataServiceQuery('KlaviyoProfile', 'ProfileModel', DataServiceEntities.ProfileModelExtensionClass, key);
}

export function createInitializeKlaviyoLoyaltyProfileInput(model: DataServiceEntities.IProfileModel): IDataServiceRequest {
    const query = klaviyoProfileQuery();
    return query.createDataServiceRequestForOperation(
        'InitializeKlaviyoLoyaltyProfile',
        true,
        DataServiceEntities.ProfileModelExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IProfileModel' },
        { model: model }
    );
}

export function initializeKlaviyoLoyaltyProfileAsync(
    context: IContext,
    model: DataServiceEntities.IProfileModel
): AsyncResult<DataServiceEntities.IProfileModel> {
    const request = createInitializeKlaviyoLoyaltyProfileInput(model);
    return callActionOrExecute<DataServiceEntities.IProfileModel>(request, context.callerContext);
}

export function createUpdateKlaviyoLoyaltyProfileInput(model: DataServiceEntities.IProfileModel): IDataServiceRequest {
    const query = klaviyoProfileQuery();
    return query.createDataServiceRequestForOperation(
        'UpdateKlaviyoLoyaltyProfile',
        true,
        DataServiceEntities.ProfileModelExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IProfileModel' },
        { model: model }
    );
}

export function updateKlaviyoLoyaltyProfileAsync(
    context: IContext,
    model: DataServiceEntities.IProfileModel
): AsyncResult<DataServiceEntities.IProfileModel> {
    const request = createUpdateKlaviyoLoyaltyProfileInput(model);
    return callActionOrExecute<DataServiceEntities.IProfileModel>(request, context.callerContext);
}

export function createGetKlaviyoLoyaltyProfileInput(email: string): IDataServiceRequest {
    const query = klaviyoProfileQuery();
    return query.createDataServiceRequestForOperation(
        'GetKlaviyoLoyaltyProfile',
        false,
        DataServiceEntities.ProfileModelExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IProfileModel' },
        { email: email }
    );
}

export function getKlaviyoLoyaltyProfileAsync(context: IContext, email: string): AsyncResult<DataServiceEntities.IProfileModel> {
    const request = createGetKlaviyoLoyaltyProfileInput(email);
    return callActionOrExecute<DataServiceEntities.IProfileModel>(request, context.callerContext);
}

export function createGetKlaviyoSettingsInput(): IDataServiceRequest {
    const query = klaviyoProfileQuery();
    return query.createDataServiceRequestForOperation(
        'GetKlaviyoSettings',
        false,
        '',
        'false',
        { bypassCache: 'none', returnEntity: '' },
        {}
    );
}

export function getKlaviyoSettingsAsync(context: IContext): AsyncResult<string> {
    const request = createGetKlaviyoSettingsInput();
    return callActionOrExecute<string>(request, context.callerContext);
}
